import { render, staticRenderFns } from "./MytemplateCanvas.vue?vue&type=template&id=40e74a48&"
import script from "./MytemplateCanvas.vue?vue&type=script&lang=js&"
export * from "./MytemplateCanvas.vue?vue&type=script&lang=js&"
import style0 from "./MytemplateCanvas.vue?vue&type=style&index=0&id=40e74a48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports